import AssetsManager from '../../../core/assets/AssetsManager';
import {Container, Graphics, Text} from 'pixi.js';
import LayoutBuilder from '../../../core/utils/LayoutBuilder';
import LayoutElement from '../../../core/view/model/LayoutElement';
import Button from '../../../core/view/ui/Button';
import ControlEvent from '../../../core/control/event/ControlEvent';
import {UIPanelEvent} from '../../control/event/UIPanelEvent';
import {SlotGameEventExtension} from '../../../../jewels-of-wizard/control/event/SlotGameEventExtension';
import {autoscaleText} from '../../../core/utils/Utils';
import GameService from '../../../../jewels-of-wizard/services/GameService';
import {container} from 'tsyringe';
import Wallet from '../../../slots/model/Wallet';
import SlotMachine from '../../../slots/model/SlotMachine';
import { SlotMachineEvent } from '../../../slots/model/event/SlotMachineEvent';
import * as PIXI from 'pixi.js';
import SoundList from '../../sound/SoundList';
import SoundManager from '../../../core/sound/SoundManager';
let isOnceClicked: boolean = false;
export default class PopupFeatureBuy extends Container {

    private tfMainText: Text;
    private tfAmount: Text;
    private tfAmountArea: Graphics;
    private tfFreespins:Text;

    private btnStart:Button;
    private btnCancel:Button;
    constructor() {
        super();
        LayoutBuilder.create(AssetsManager.layouts.get('PopupFeatureBuy'), this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });

        this.tfAmountArea.alpha = 0;

        if(this['tfMainText']) {
            this['tfMainText'].style.align = 'center';
        }

        this.tfFreespins.style.align = 'center';

        autoscaleText(this.tfFreespins, this.tfFreespins.style.fontSize as number, 537, 244.5);

        const gs: GameService = container.resolve<GameService>('GameService')
        const wallet: Wallet = container.resolve(Wallet);
        const sm: SlotMachine = container.resolve(SlotMachine);
        sm.on(SlotMachineEvent.BET_VALUE_CHANGED, this.onBetValueChanged, this);
        this.tfAmount.text = wallet.getCurrencyValue(gs.featureBuyConfig.Rate * sm.totalBet * wallet.coinValue, true);
        autoscaleText(this.tfAmount, this.tfAmount.style.fontSize as number, this.tfAmountArea.width, this.tfAmountArea.height);

        this.btnStart.on('pointerup', this.onBtnStart, false)
        this.btnCancel.on('pointerup', this.onBtnCancel, false)
        this.on('added', this.onAdded, this);
    }

    private onAdded(){
        const gs: GameService = container.resolve<GameService>('GameService')
        const wallet: Wallet = container.resolve(Wallet);
        const sm: SlotMachine = container.resolve(SlotMachine);
        this.tfAmount.text = wallet.getCurrencyValue(gs.featureBuyConfig.Rate * sm.totalBet * wallet.coinValue, true);

        autoscaleText(this.tfAmount, this.tfAmount.style.fontSize as number, 537,120);
        isOnceClicked = false;
    }

    public onBetValueChanged() {
        const wallet: Wallet = container.resolve(Wallet);
        const sm: SlotMachine = container.resolve(SlotMachine);
        const gs: GameService = container.resolve<GameService>('GameService')
        this.tfAmount.text = wallet.getCurrencyValue(gs.featureBuyConfig.Rate * sm.totalBet * wallet.coinValue, true);
    }

    protected customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;

        switch (le.customClass) {
            case 'Button':
                instance = new Button(le);
                break;
        }
        return instance;
    }


    private onBtnStart():void{
        if(isOnceClicked) return;
        isOnceClicked = true;
        SoundManager.play(SoundList.UI_BUTTON_CLICK);
        new ControlEvent(SlotGameEventExtension.BUY_FREESPINS).dispatch();
        new ControlEvent(UIPanelEvent.HIDE_POPUP).dispatch();
    }

    private onBtnCancel():void{
        SoundManager.play(SoundList.UI_BUTTON_CLICK);
        new ControlEvent(UIPanelEvent.HIDE_POPUP).dispatch();
    }
}
